import { FC, memo } from 'react';

import cn from 'classnames';

import { OModal } from '@src/shared';
import { Button, Stack } from '@mui/material';
import BackgroundEffectsTabs from '../BackgroundEffectsTabs';
import { AdvancedSettings } from '../BackgroundEffects/AdvancedSettings';

import { TBackgroundEffect } from '@src/types';

import './backgroundEffectsSimpleModal.scss';

interface IProps {
  isModalOpen: boolean;
  isApplyButtonDisabled: boolean;
  selectedBackgroundEffect: TBackgroundEffect;
  removeBackgroundEffect: () => void;
  onSelectBackgroundEffect: (effect: TBackgroundEffect) => void;
  handleApplyChanges: () => void;
  handleCloseModal: () => void;
  classes?: {
    customWrapper?: string;
  };
}

const BackgroundEffectsSimpleModal: FC<IProps> = ({
  isModalOpen,
  isApplyButtonDisabled,
  removeBackgroundEffect,
  onSelectBackgroundEffect,
  handleApplyChanges,
  handleCloseModal,
  classes,
}) => {
  return (
    <OModal
      isOpen={isModalOpen}
      classes={{
        container: cn('change-background-layout-modal', classes?.customWrapper),
        closeIcon: 'close-icon',
      }}
      onClose={handleCloseModal}
    >
      <div className="container-layout">
        <div className="backgrounds-section-container">
          <BackgroundEffectsTabs onSelectBackgroundEffect={onSelectBackgroundEffect} />
          {process.env.REACT_APP_ENV !== 'production' && <AdvancedSettings />}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            className="change-background-footer"
          >
            <Button variant="contained" className={cn('btn remove-background-btn')} onClick={removeBackgroundEffect}>
              Clear background
            </Button>
            <Button
              variant="contained"
              disabled={isApplyButtonDisabled}
              className={cn('btn apply-background-btn', { disabled: isApplyButtonDisabled })}
              onClick={handleApplyChanges}
            >
              Apply
            </Button>
          </Stack>
        </div>
      </div>
    </OModal>
  );
};

export default memo(BackgroundEffectsSimpleModal);
